__turbopack_context__.v({
  "__hide": "LoaderCircle-module-scss-module__f6gl7G____hide",
  "loader": "LoaderCircle-module-scss-module__f6gl7G__loader",
  "loaderApple": "LoaderCircle-module-scss-module__f6gl7G__loaderApple",
  "nl_preloader": "LoaderCircle-module-scss-module__f6gl7G__nl_preloader",
  "nl_reploader_father": "LoaderCircle-module-scss-module__f6gl7G__nl_reploader_father",
  "rotation": "LoaderCircle-module-scss-module__f6gl7G__rotation",
});
